$(function () {
  'use strict';

  var $form = $('form[data-report-post-form]');

  $form.on('click', '.remove-accepts-nested-attributes-for-fields', function (event) {
    event.preventDefault();
    $(this).parent().find('[id$=\'_destroy\']').val('true');
    $(this).closest('.accepts-nested-form').hide();
  }).on('click', '.logical-delete-accepts-nested-attributes-for-fields', function (event) {
    event.preventDefault();
    $(this).prev('[type="hidden"]').val('deleted');
    $(this).closest('.accepts-nested-form').hide();
  }).on('click', '.add-accepts-nested-attributes-for-field', function (event) {
    event.preventDefault();
    var regexp, time;
    var itemId = $(this).data('item-id');
    time = new Date().getTime();
    regexp = new RegExp($(this).data('id'), 'g');
    var $container = $('.accepts-nested-attributes-for-field[data-item-id=' + itemId + ']');
    var $list = $container.find('.poll-form__choice-list');
    var $choice = $(this).data('fields').replace(regexp, time);
    $list.append('<li class="poll-form__choice-item">' + $choice + '</li>');
  });
}.call(this));
